module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAATLoWrAAAAJFBMVEVHcExSFPpTFfpPDfdUFPpUFPp7AP9UFPlDAP9TFPpTFPlUFPl8EJNEAAAADHRSTlMAM2cUrpUCuQOQn33p7dLOAAAAlUlEQVQoz2NgGMTASBlMcQgpwIWknAxAVGLIBIQqF5AyNtFSAbgQswpIWWJ4YAMDijKgIjEk80HKgIoSUOx0UUZVBFLmjaYIqMwdTREDQ6N7tQGqCJuki4syqlBi+EQVJxRlQDdJGKEqA7mJGUUZxOEoyhrBbkJRZgpxk5ELPLw4pCAOZ9ZChJehBJQWwAjwtMGcGhgAOl0bSjKt/gEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trends/dyn_dyn_ic_delete.png
// module id = NPYA
// module chunks = 1